/* assets/ee-search.js
   Inline expanding search (Eye Essentials) — mobile first-tap fix
   - Uses pointerdown on touch/coarse pointers
   - Stops propagation on internal taps/clicks
   - Keeps desktop click behavior intact
*/
(() => {
  const wrap = document.getElementById('eeSearch');
  if (!wrap) return;

  // Prevent double-initialization if this script runs twice
  if (wrap.dataset.eeSearchInit === '1') return;
  wrap.dataset.eeSearchInit = '1';
  
  const btn = wrap.querySelector('[data-ee-search-trigger]');
  const input   = wrap.querySelector('.ee-search-input');
  const results = wrap.querySelector('#ee-predictive-results');

  // Detect touch/coarse pointers (mobile/tablet)
  const isCoarsePointer = window.matchMedia
    ? window.matchMedia('(pointer: coarse)').matches
    : ('ontouchstart' in window);

  const open = () => {
    wrap.classList.add('open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (input) input.focus({ preventScroll: true });
  };

  const close = () => {
    wrap.classList.remove('open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (results) results.hidden = true;
    if (input) input.value = '';
  };

  const safeOpen = (e) => {
    if (e) {
      // Critical for mobile: prevent default and stop bubbling so
      // outside handlers don't immediately close after opening.
      e.preventDefault();
      e.stopPropagation();
    }
    open();
  };

  // --- Open handlers ---
  if (btn) {
    // On mobile/tablet, open on pointerdown for snappy first-tap
    if (isCoarsePointer) {
      btn.addEventListener('pointerdown', safeOpen, { passive: false });
    }
    // Keep click for desktop (and as fallback)
    btn.addEventListener('click', safeOpen);
  }

  // --- Keep interactions inside from closing the search ---
  const stop = (e) => e.stopPropagation();
  wrap.addEventListener('pointerdown', stop);
  wrap.addEventListener('click', stop);

  // --- Close on outside interaction / Escape ---
  const maybeClose = (e) => {
    if (!wrap.contains(e.target)) close();
  };
  // Support both pointerdown (mobile-first) and click (desktop safety)
  document.addEventListener('pointerdown', maybeClose);
  document.addEventListener('click', maybeClose);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // --- Predictive search integration ---
  // Expecting theme's predictive-search script to dispatch this event
  document.addEventListener('predictive-search:render', (event) => {
    const html = event?.detail?.results;
    if (!html || !results) return;
    results.innerHTML = html;
    // Only show when there's a query
    results.hidden = !(input && input.value && input.value.trim());
  });

  if (input) {
    input.addEventListener('input', () => {
      if (!input.value.trim() && results) results.hidden = true;
    });
  }
})();
